const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIntChipax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4cf92ab-3b54-46a7-875d-98674a208721",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ecdd6589-1e31-46be-8c79-16fede89dfb0{fill:#5cc3af;}.a893af05-1217-4457-98a7-45d8207e302d{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "ecdd6589-1e31-46be-8c79-16fede89dfb0",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a893af05-1217-4457-98a7-45d8207e302d",
    d: "M30.53,37.51c-.13,0-.19-.12-.26-.19l-4-4c-.21-.22-.32-.23-.54,0-1.32,1.35-2.67,2.67-4,4-.2.2-.3.19-.49,0L10.13,26.2c-.17-.17-.18-.26,0-.43q5.58-5.57,11.14-11.15c.19-.19.29-.16.46,0,1.34,1.35,2.69,2.69,4,4,.19.19.3.2.49,0,1.34-1.35,2.69-2.68,4-4,.2-.2.3-.18.49,0q5.55,5.58,11.12,11.12c.17.17.18.26,0,.43q-5.58,5.56-11.14,11.14ZM26,20.49l-.16.15-5.16,5.15c-.15.15-.14.24,0,.39.55.54,1.1,1.09,1.64,1.64l3.46,3.45c.1.1.16.27.35.08q2.59-2.61,5.2-5.2c.13-.13.12-.21,0-.34l-5.18-5.17ZM12.1,25.4l.2,0h7a.56.56,0,0,0,.42-.21L25,19.9c.18-.17.16-.26,0-.42-1.08-1.07-2.16-2.13-3.21-3.22-.24-.24-.37-.22-.6,0-2.93,2.95-5.88,5.89-8.82,8.83Zm0,1.14.19.22,9,9c.2.2.3.15.46,0,1.08-1.09,2.15-2.17,3.24-3.24.19-.19.2-.28,0-.48q-2.65-2.62-5.28-5.27a.69.69,0,0,0-.54-.23H12.09Zm27.76-1.16a1.93,1.93,0,0,0-.17-.21l-8.95-9c-.17-.18-.28-.2-.46,0Q28.67,17.84,27,19.44c-.22.21-.18.32,0,.52q2.64,2.61,5.25,5.25a.7.7,0,0,0,.55.22H39.5C39.61,25.42,39.73,25.46,39.85,25.38Zm0,1.2-.14,0H32.69a.47.47,0,0,0-.35.18C30.57,28.49,28.8,30.27,27,32c-.21.21-.16.32,0,.49,1.07,1.06,2.14,2.12,3.19,3.2.24.24.36.19.57,0,2.94-3,5.9-5.91,8.85-8.86Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntChipax);
export default __webpack_public_path__ + "static/media/Int_CHIPAX.64eba1b5df13b19cd0f454a5dcf45b65.svg";
export { ForwardRef as ReactComponent };